import { getThemeByHost } from "@/utils/api/spaces"
import { useLocalStorage } from "hooks/useLocalStorage"
import { createContext, useContext, useEffect } from "react"
import { DEFAULT_THEME, resolveTheme, Theme } from "./defaultTheme"

export const ThemeContext = createContext(null)

export const useTheme = () => useContext<Theme>(ThemeContext)

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useLocalStorage<Theme>("_theme_", DEFAULT_THEME)

  useEffect(() => {
    fetchTheme()
  }, [])

  const refereshWithHost = async (host: string) => {
    try {
      let theme = await getThemeByHost(host)
      setTheme(resolveTheme(theme))
    } catch (error) {}
  }

  const fetchTheme = async () => {
    if (typeof window === "undefined") return
    try {
      let theme = await getThemeByHost()
      setTheme(resolveTheme(theme))
    } catch (error) {
      setTheme(DEFAULT_THEME)
    }
  }

  return (
    <ThemeContext.Provider value={{ ...theme, refereshWithHost }}>
      <style jsx global>
        {`
          :root {
            --color-company-black: ${theme?.black};
            --color-company-white: ${theme?.white};
            --color-company-blue-700: ${theme?.blue?.["700"] || ""};
            --color-company-blue-600: ${theme?.blue?.["600"] || ""};
            --color-company-blue-500: ${theme?.blue?.["500"] || ""};
            --color-company-blue-100: ${theme?.blue?.["100"] || ""};
            --color-company-red-500: ${theme?.red?.["500"] || ""};
            --image-auth-img: ${theme?.authimg};
            --image-auth-logo: ${theme?.authlogo};
            --image-logo-symbol: ${theme?.logosymbol};
            --color-intro: ${theme?.intro};
          }
        `}
      </style>
      {children}
    </ThemeContext.Provider>
  )
}
